<template>
  <div :class="{ disabled: disabled }">
    <slot :disabled="disabled" />
  </div>
</template>

<script>
export default {
  name: 'Disablable',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
};
</script>
